import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/base_corp",
    name: "base_corp",
    redirect: "/base_corp/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "base_corp_index",
        meta: {title: "公司信息", isIndex: true, keepAlive: true},
        component: () => import("@/pages/base/corp/index")
      }
    ]
  },
  {
    path: "/base_customer",
    name: "base_customer",
    redirect: "/base_customer/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "base_customer_index",
        meta: {title: "客户管理",  isIndex: true, keepAlive: true},
        component: () => import("@/pages/base/customer/index")
      },
      {
        path: "edit",
        name: "base_customer_edit",
        meta: {title: "编辑客户", isIndex: false, keepAlive: false},
        component: () => import("@/pages/base/customer/edit")
      },
      {
        path: "view",
        name: "base_customer_view",
        meta: {title: "查看客户", isIndex: false, keepAlive: false},
        component: () => import("@/pages/base/customer/view")
      }
    ]
  },
  {
    path: "/base_defdoc",
    name: "base_defdoc",
    redirect: "/base_defdoc/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "base_defdoc_index",
        meta: {title: "字典管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/base/defdoc/index")
      },
      {
        path: "view",
        name: "base_defdoc_view",
        meta: {title: "字典维护", isIndex: false, keepAlive: false},
        component: () => import("@/pages/base/defdoc/view")
      }
    ]
  },
  {
    path: "/base_deptdoc",
    name: "base_deptdoc",
    redirect: "/base_deptdoc/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "base_deptdoc_index",
        meta: {title: "部门管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/base/deptdoc/index")
      }
    ]
  },
  {
    path: "/base_psndoc",
    name: "base_psndoc",
    redirect: "/base_psndoc/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "base_psndoc_index",
        meta: {title: "人员管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/base/psndoc/index")
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/base.js